import type { Variants } from "framer-motion";

/** Shared page transition config — used by `Header` around the animated outlet. */
export const pageVariants: Variants = {
  initial: { opacity: 0 },
  in: {
    opacity: 1,
    transition: { type: "tween", ease: "easeOut", duration: 0.4 },
  },
  out: {
    opacity: 0,
    transition: { type: "tween", ease: "easeIn", duration: 0.35 },
    // Keep the layer invisible after WAAPI is removed, before React unmounts it.
    transitionEnd: { visibility: "hidden" },
  },
};

export const pageTransition = {
  type: "tween" as const,
  ease: "easeInOut" as const,
  duration: 0.4,
};
